const useTeamActivitiesStepModifier = ({ step, projectStage }) => {
	const formattedStage =
		projectStage.stage.substr(0, 1).toUpperCase() + projectStage.stage.substr(1).toLowerCase();
	const responsiblePerson = step.responsiblePerson ? { [formattedStage]: step.responsiblePerson } : undefined;

	return { ...step, responsiblePerson };
};

export default useTeamActivitiesStepModifier;
